interface RefreshTableDataOptions {
  hasFilterParams: boolean;
  isCrudFiltered?: boolean;
  refreshFilteredData: () => Promise<void>;
  refreshListData: () => Promise<void>;
  refreshCrudSearchData?: () => Promise<void>;
}

export const refreshTableData = async ({
  hasFilterParams,
  isCrudFiltered = false,
  refreshFilteredData,
  refreshListData,
  refreshCrudSearchData
}: RefreshTableDataOptions) => {
  if (hasFilterParams) {
    await refreshFilteredData();
    return;
  }

  if (isCrudFiltered && refreshCrudSearchData) {
    await refreshCrudSearchData();
    return;
  }

  await refreshListData();
};
